// DS: i5.10
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const PrivateFill: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M10 4.5c0-.361.187-.717.58-1.016A2.44 2.44 0 0112 3c.48 0 1.018.178 1.42.484.393.3.58.655.58 1.016V5a1 1 0 102 0v-.5c0-1.136-.612-2.031-1.369-2.607A4.437 4.437 0 0012 1c-.92 0-1.883.323-2.631.893C8.612 2.469 8 3.363 8 4.5V5a1 1 0 002 0v-.5z"></path>
        <path
          fillRule="evenodd"
          d="M20.664 16.912l-8 5.84c-.378.33-.95.33-1.328 0l-8-5.84A.974.974 0 013 16.178v-5.876c0-.345.184-.665.486-.842l3.937-2.32c.35-.205.79-.183 1.115.056L12 9.746l3.462-2.55c.325-.24.766-.261 1.115-.056l3.938 2.32a.978.978 0 01.485.842v5.876c0 .28-.122.548-.336.734zM12 13.7a1 1 0 011 1v1.7a1 1 0 11-2 0v-1.7a1 1 0 011-1z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
PrivateFill.displayName = 'PrivateFill';

export default PrivateFill;
